module.exports = {
	_init: function() {
		this.$el.on('mixStart', function(event, currentState, futureState){
			if (currentState.activeFilter !== futureState.activeFilter) {
				$(".recent-excerpt").slideUp();
			}
		});	
	},
}
